import { ACCESS_DENIED } from '@/constants/routes';
import { useUserStore } from '@/stores/user';

export default function accessToRooms() {
  return () => {
    const access = useUserStore().companySectionsRights;

    if (access.find(item => item.name === 'rooms')) {
      return true;
    }

    return { name: ACCESS_DENIED };
  };
}
